import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { CiInstagram, CiFacebook } from 'react-icons/ci'
import { Link } from 'gatsby'
import { language } from '../../types'
import { useRecoilValue } from 'recoil'
import { langAtom } from '../../atoms'
import { langFromPath, localizedPath, localize } from '../../utils/language'
import { useLocation } from '@reach/router'

const footerList = [
  {
    link: '/about/',
    JA: 'へんこつについて',
    EN: 'About',
    ZH: '关于我们',
    TW: '關於我們',
    KO: '소개',
  },
  {
    link: '/menus/',
    JA: 'メニュー',
    EN: 'Menu',
    ZH: '菜单',
    TW: '菜單',
    KO: '메뉴',
  },
  {
    link: '/branch/',
    JA: '店舗一覧',
    EN: 'Locations',
    ZH: '门店一览',
    TW: '分店一覽',
    KO: '매장 안내',
  },
  {
    link: '/contact/',
    JA: 'お問い合わせ',
    EN: 'Contact',
    ZH: '联系我们',
    TW: '聯絡我們',
    KO: '문의',
  },
  {
    link: '/companyInfo/',
    JA: '会社情報',
    EN: 'Company',
    ZH: '公司信息',
    TW: '公司資訊',
    KO: '회사 정보',
  },
]

export default function Footer() {
  const location = useLocation()
  const recoilLang = useRecoilValue<language>(langAtom)
  const lang = langFromPath(location.pathname) || recoilLang

  return <footer
    className='bg-henkotsu w-full px-4 py-8 sm:px-10 md:px-16 xl:py-16 xl:px-28'
  >
    <div className='xl:flex max-w-screen-xl'>
      <nav className='lg:flex lg:gap-16 mx-auto'>
        <Link to={localizedPath(lang)}>
          <StaticImage
            className='w-32 mx-auto sm:w-40 xl:w-56'
            alt='Henkotsu'
            src='../../images/logos/logo.webp'
          />
        </Link>
        <div
          className='text-sm flex flex-wrap mt-6 mx-auto text-gray-600 sm:w-[620px] lg:w-[780px] lg:text-base lg:mt-2 xl:mt-6'
        >
          {footerList.map(i => <p
            key={localize(i, lang)}
            className='mx-2 mt-3 lg:mx-4'>
            <Link to={localizedPath(lang, i.link)}>
              {localize(i, lang)}
            </Link>
          </p>)}
          {lang === 'JA' && <p
            className='mx-2 mt-3 lg:mx-4'>
            <Link to='/careers/'>
              採用情報
            </Link>
          </p>}
          <p className='mx-2 mt-3 lg:mx-4'>
            <a
              href='https://firebasestorage.googleapis.com/v0/b/udon-restaurant.appspot.com/o/Privacy_policy.pdf?alt=media&token=76740e0f-274a-44bd-a987-7ff8700bd8af'
              target='_blank'
              rel='noopener noreferrer'
            >
              {lang === 'JA' ? 'プライバシーポリシー' : lang === 'KO' ? '개인정보 처리방침' : lang === 'EN' ? 'Privacy Policy' : lang === 'TW' ? '隱私權政策' : '隐私政策'}
            </a>
          </p>
        </div>
      </nav>
      <div className='flex justify-end gap-4 text-4xl text-primary-500 mt-8 xl:mt-20'>
        <a
          href='https://www.instagram.com/henkotsu_udon/'
          aria-label='Instagram of henkotu'
        >
          <CiInstagram />
        </a>
        <a
          href='https://www.facebook.com/HenkotsuUdon/?locale=ja_JP'
          aria-label='facebook of henkotu'
        >
          <CiFacebook />
        </a>
      </div>
    </div>
    <p className='text-center text-gray-600 leading-relaxed text-xs pt-8 lg:text-sm lg:mt-12'>
      { lang === 'JA' ? '© 2024 - うどんれすとらん へんこつ ALL RIGHTS RESERVED' : '© 2024 - Udon Restaurant Henkotsu ALL RIGHTS RESERVED' }
    </p>
  </footer>
}
